import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "../contexts/AuthContext";
import { PermissaoProvider } from "../contexts/PermissaoContext";
import { MovimentacaoProvider } from "../contexts/MovimentacaoContext";
import theme from "./theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <PermissaoProvider>
          <MovimentacaoProvider>{children}</MovimentacaoProvider>
        </PermissaoProvider>
      </AuthProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default AppProviders;
